<template>
    <li class="notification-item" :class="{ 'notification-item--new': item.unread }">
        <div class="notification-item__heading">
            <strong>{{ item.type.startsWith('supplier.') ? item.supplier_name : item.title }}</strong>
            <span v-if="item.unread" class="mc-chip">Nuova</span>
        </div>
        <p v-if="item.active && item.type !== 'manual'"><strong>{{ number(item.count, 0) }} {{ item.unit || 'ODP' }}</strong> · {{ item.title }}</p>
        <p v-else-if="item.active" class="notification-item__message">{{ item.message }}</p>
        <p v-else>Attività concluse</p>
        <p v-if="item.priority === 'urgent' || item.overdue"><strong>{{ item.overdue ? 'Scaduta' : 'Urgente' }}</strong> · {{ item.priority_reason }}</p>
        <p v-if="item.escalated"><strong>Sollecito</strong> · Attività rimasta senza incaricato oltre il tempo previsto.</p>
        <p v-if="item.due_at" class="t-caption">Scadenza {{ updatedAt(item.due_at) }}</p>
        <p v-if="item.snoozed_until" class="t-caption">Promemoria rinviato al {{ updatedAt(item.snoozed_until) }}</p>
        <p v-if="item.type !== 'manual' && item.message" class="notification-item__message">{{ item.message }}</p>
        <p v-if="item.partial_count" class="notification-item__detail t-caption">{{ number(item.partial_count, 0) }} ODP parzialmente disponibili</p>
        <p v-if="item.allocation_count" class="notification-item__detail t-caption">{{ number(item.allocation_count, 0) }} ODP richiedono la verifica dell’allocazione</p>
        <div class="notification-item__footer">
            <span class="notification-item__detail t-caption">{{ updatedAt(item.updated_at) }}</span>
            <v-btn v-if="item.active && item.target" text color="primary" :to="item.target" @click="$emit('open')">Apri elenco<v-icon right small>mdi-arrow-right</v-icon></v-btn>
        </div>
        <div class="notification-item__footer">
            <v-btn v-if="item.type !== 'centri.controlli'" text color="primary" :to="{ name: 'LeMieAttivita', query: { notifica: item.id, ...(item.active ? {} : { stato: 'closed' }) } }" @click="$emit('open')">Gestisci attività</v-btn>
            <reminder-control v-if="item.active" :id="item.id" :revision="item.revision" :snoozed-until="item.snoozed_until" @changed="$emit('refresh')" />
        </div>
    </li>
</template>
<script>
import { number, updatedAt } from "../../assets/mecom/js/format.mjs";
import ReminderControl from './ReminderControl.vue';
export default {
    name: "NotificationItem",
    components: { ReminderControl },
    props: { item: { type: Object, required: true } },
    mounted() {
        this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.75) && this.item.unread) {
                this.$emit("seen", { id: this.item.id, revision: this.item.revision });
            }
        }, { threshold: 0.75 });
        this.observer.observe(this.$el);
    },
    beforeDestroy() { this.observer?.disconnect(); },
    methods: { number, updatedAt },
};
</script>
